// app/services.ts — dependency bundle injected via context (keeps components testable).
import { ApiClient } from '../lib/api';
import { config, type PublicConfig } from '../lib/env';
import { createDefaultAuth, type AuthService } from '../lib/supabase';

export interface AppServices {
  auth: AuthService;
  api: ApiClient;
  config: PublicConfig;
}

export function createDefaultServices(): AppServices {
  const auth = createDefaultAuth();
  const api = new ApiClient({ gatewayUrl: config.gatewayUrl, getToken: auth.getToken });
  return { auth, api, config };
}
